
var grandparentorderfilterHTML = `

    <div class="row" style="margin-top: 0px !important;">
      <div id="columnVisabilityContainer" class="col-sm-4 col-md-2" style="margin-top:22px">
      </div>


      <div id="client_orders_filter" class="form-group col-sm-4 col-md-2">

        <label for="sorOrderSearch">Search</label>
        <input type="search" id="orderSearch" class="form-control form-control-sm"
        placeholder="" aria-controls="client_orders">
      </div>

    </div>
    `

class GrandParentOrderListTable extends DataTable {


  constructor(table_id) {
    super(table_id, false);
    this.serverSide = true;
    this.setupTable();
    this.addStatusSearchEvent=false; // we don't need to search on status change, just trigger a reload
    this.addOrderFilters(grandparentorderfilterHTML);
    self = this
    var search = $.fn.dataTable.util.throttle(
        function ( val ) {
            self.table.search( val ).draw();
        },
    200);

    $('#orderSearch').on('keyup', function() {
        search(this.value);
      //self.table.search( this.value ).draw();
    })
  }

  _getTableAjax() {
    return {url: "/api/grandparent_orders/?format=datatables",
            data: function(d) {
              d.order_status = $('#orderStatusFilter').val();
            }
    }
  }
  ordering() {

      return [[ 1, "desc" ]]

  }


  rowCallback(row, data) {
    if (data.client_orders_error_ct > 0) {
      $(row).addClass('table-danger');

    }
    else if (data.client_orders_open_ct > 0) {
      $(row).addClass('table-success');
    }
    $(row).click(function() {
      window.open(`/portal/orders/grandparent/${data.slug}/`,"_self");
    })
  }
  getTableColumns() {
    var columnArray = [
                { "data": "currency_pair",
                "name": "currency_pair.slug"
                },
                {
                "data": "created_at", "sortable": true,
                 "searchable": false,
                  "render": function(data, type, row) {
                    if (type === 'sort') {
                      return data
                    }
                    if(data) {
                        return moment(data).format('llll')
                      }
                    return moment(row.exchange_timestamp).format('llll')
                  }},
                {"data": "name"},

                {"data": "client_order_id"},

                {"data": "side",
                "searchable": false,},


                { "data": "executed_qty",
                "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(8))
                    } },
                {"data": "remaining_qty",
                  "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  }
                },
                {"data": "pct_executed",
                 "searchable": false,
                "render": function(data, type, row) {
                  return Number(parseFloat(data).toFixed(2))
                }},

                { "data": "avg_price",
                "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    }},
                { "data": "gross_consideration",
                 "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},

                { "data": "net_consideration",
                "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},


                { "data": "client_orders_open_ct",
                "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseInt(data))
                  } },
                {"data": "strategy",
                  "name": "strategy.slug"},


            ]

            return columnArray
          }

}
